module.exports = __webpack_public_path__ + "static/media/EAI-07.cb7f6544.jpg";